import PropTypes from 'prop-types';
import { FormikInput } from '@febos-io/design';

import { useTranslation } from '../../../hooks';
import { InputProps } from "./types";

export function FilterEmail({
  name,
  config
}:InputProps) {
  const { t } = useTranslation();

  return (
    <FormikInput
      name={`${name}[0]`}
      type="email"
      label={`${t(config.name)}`}
      placeholder={`${t(config.name)}`}
    />
  );
}

FilterEmail.propTypes = {
  name: PropTypes.string,
  config: PropTypes.object
};

export default FilterEmail;
